export default __webpack_public_path__ + "static/media/ShubhamWagh.4bc70236.webp";